export var TRANSLATION_KEY = 'cross-platform-sidebar-admin';